<template>
  <div
    class="analytics-page"
  >
    <div class="content-heading">
      <i class="ic-head-icon">
        <img src="@/assets/images/sidebar/analytics.svg" alt="Analytics" />
      </i>
      <h4 class="head-title">Analytics</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover
        target="help"
        triggers="hover"
        content="This section allows you to view the summary of your performance in sales, acquisition, engagement and rewards program"
      >
      </b-popover>
      <AppTabs :tabs="tabs" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
import DashboardTab from "./DashboardTab";
import Datepicker from "vue-bulma-datepicker";
import permission from "@/services/user.permission";
import { mapState, mapActions } from "vuex";
import _ from "lodash";

export default {
  name: "AnalyticsGraph",
  components: {
    Datepicker,
    AppTabs,
    DashboardTab,
  },
  data() {
    return {
      permission: permission,
      tabs: [
        {
          name: "Dashboard",
          href: "/analytics/dashboard",
          access: "analytics.analytics",
        },
        {
          name: "eStore Analytics",
          href: "/analytics/estore-analytics",
          access: false,
          beta: true,
        },
        {
          name: "Estore Analytics",
          href: "/analytics/estore-quicksight",
          access: "analytics.estore-quicksight",
          beta: true,
        },
        {
          name: "Loyalty Analytics",
          href: "/analytics/loyalty-analytics",
          access: false,
          beta: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions("analytics", ["getInquiro"]),
  },
  computed: {
    ...mapState("auth", ["user", "enabledTopUps"]),
    ...mapState("accountProfile", ["detail"]),
    ...mapState("analytics", ["inquiro"]),
  },
  async created() {
    if (this.permission.hasAccess("analytics.inquiro")) {
      await this.getInquiro();

      if (this.inquiro) {
        this.tabs.push({
          name: "Inquiro",
          href: "/analytics/inquiro",
          access: "analytics.inquiro",
        });
      }
    }

    if (
      this.user.merchant_uuid === "aa1c538b-df7e-4654-be6e-d7e6f5977d53" ||
      this.user.merchant_uuid === "6e277127-5e4b-48aa-a15c-0e1757d3a5a2"
    ) {
      this.tabs.push(
        {
          name: "Sales",
          href: "/analytics/sales",
          access: "analytics.sales",
        },
        {
          name: "Members",
          href: "/analytics/members",
          access: "analytics.members",
        }
      );
    }

    if (!_.has(this.detail, "plan_details"))
      await this.$store.dispatch("accountProfile/assignMerchantDetail");

    if (this.enabledTopUps.includes("estore")) {
      this.tabs.find((tab) => tab.name === "eStore Analytics").access = "analytics.estore";
      this.tabs.find((tab) => tab.name === "Estore Analytics").access = "analytics.estore-quicksight";
    }

    if (this.user.role === "admin" && this.detail.plan_details.enable_loyalty) {
      this.tabs.find((tab) => tab.name === "Loyalty Analytics").access =
        "analytics.loyalty-quicksight";
    }
  },
};
</script>
